import RegionsService from '@/services/regions';
import { SET_REGIONS } from '../mutation-types';

const state = {
	regions: []
};

const getters = {
	getAll(state) {
		return state.regions;
	},

	getPageDetails(state) {
		return state.pageDetails;
	}
};

const mutations = {
	[SET_REGIONS] (state, payload) {
		state.regions = payload;
	},
};

const actions = {
	all({ commit }, query) {
		return RegionsService.all(query)
			.then((response) => {
				commit(SET_REGIONS, response);
				return Promise.resolve(response);
			})
			.catch((error) => Promise.reject(error));
	},

	add({ commit, actions }, region) {
		return RegionsService.add(region)
			.then((response) => Promise.resolve(response))
			.catch((error) => Promise.reject(error));
	},

	show({ commit, actions }, id) {
		return RegionsService.show(id)
			.then((response) => Promise.resolve(response))
			.catch((error) => Promise.reject(error));
	},

	update({ commit, actions }, region) {
		return RegionsService.update(region.id, region)
			.then((response) => Promise.resolve(response))
			.catch((error) => Promise.reject(error));
	},	

	delete({ commit, actions }, id) {
		return RegionsService.delete(id)
			.then((response) => Promise.resolve(response))
			.catch((error) => Promise.reject(error));
	}
};

const namespaced = true;

export default {
	namespaced,
	state,
	actions,
	getters,
	mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/regions.js